export default "__VITE_ASSET__Dn3elcs5__"